import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTextarea,{attrs:{"name":"input-7-1","label":_vm.label,"value":_vm.defaultValue,"hint":_vm.hint,"outlined":_vm.outlined,"filled":_vm.filled,"background-color":_vm.backgroundColor,"color":_vm.color,"clearable":_vm.clearable,"clear-icon":_vm.icon},on:{"change":_vm.getTextContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }